import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent } from './components/input/input.component';
import { PrimeNgModule } from '../prime-ng.module';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteInputComponent } from './components/auto-complete-input/auto-complete-input.component';
import { CitiesService } from './services/cities.service';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { DotSpinnerComponent } from './components/loader/dot-spinner/dot-spinner.component';
import { PasswordModule } from 'primeng/password';
import { CityDropdownComponent } from './components/city-dropdown/city-dropdown.component';
import { ImageCropperComponent } from './components/image-cropper/image-cropper.component';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { LogoDirective } from './logo/logo.directive';

@NgModule({
  declarations: [
    InputComponent,
    ProgressBarComponent,
    CalendarComponent,
    AutoCompleteInputComponent,
    CheckboxComponent,
    DropdownComponent,
    DotSpinnerComponent,
    CityDropdownComponent,
    ImageCropperComponent,
    LogoDirective,
  ],
  imports: [
    CommonModule,
    PrimeNgModule,
    CalendarModule,
    FormsModule,
    ReactiveFormsModule,
    PasswordModule,
    DynamicDialogModule,
  ],
  exports: [
    InputComponent,
    ProgressBarComponent,
    CalendarComponent,
    AutoCompleteInputComponent,
    CheckboxComponent,
    DropdownComponent,
    CommonModule,
    PrimeNgModule,
    DotSpinnerComponent,
    CityDropdownComponent,
    ImageCropperComponent,
    LogoDirective,
  ],
  providers: [CitiesService],
})
export class SharedModule {}
